/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import * as _ from 'underscore';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';

class MastodonHandle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            serviceId: this.props.app.config.constants.POST_SVC_MASTODON,
            mastodonHandle: '',
            error: ''
        };

        this.collectHandle = this.collectHandle.bind(this);
        this.connectService = ConnectMixin.connectService.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.closeAction = this.closeAction.bind(this);
        this.buttonRef = React.createRef();

    }

    componentDidMount() {
        window.addEventListener('keydown', this.onKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyDown);
    }

    collectHandle(e) {
        e.preventDefault();

        let handleRE = /\@[\d\w\.\-]+\@[\d\w\.\-]+/,
            urlRE = /https?:\/\/[-A-Za-z0-9\.+&@#\/%?=~_|!:,.;]*\/@[A-Za-z0-9\.+&@#\/%?=~_|!:,.;]*/,
            error = '';

        if (!handleRE.test(this.state.mastodonHandle) && !urlRE.test(this.state.mastodonHandle)) {
            error = (
                <div>
                    Please provide a valid Mastodon handle. <br/>Either style, @username@server or https://server/@username, can be used.
                </div>
            );
        }

        if (!error) {
            this.connectService(e);
        }

        this.setState({
            error
        });

    }

    onKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();

            if (this.buttonRef.current) {
                this.buttonRef.current.click();
            }

        } else if (e.key === 'Escape') {
            this.closeAction(e);
        }
    }

    closeAction(e) {
        e.preventDefault();

        let constants = this.props.app.config.constants;

        if (this.props.context === 'onboarding') {
            this.props.closeAllModals();
        }

        if (!this.props.router.location.pathname.match("/config/social") &&
            !this.props.router.location.pathname.match("/content/post") &&
            _.findWhere(this.props.socials.counts, {type: constants.POST_SVC_MASTODON}) !== undefined) {
            this.props.switchView("chooseAcct", constants.POST_SVC_MASTODON);
        } else {
            this.props.switchView("chooseType");
        }

    }

    render () {
        let constants = this.props.app.config.constants,
            connectClass = 'btn-primary reverse-fixed',
            connectAction = null,
            error = null;

        if (this.state.mastodonHandle !== '') {
            connectClass = 'btn-primary fixed active';
            connectAction = this.collectHandle;
        }

        if (this.state.error) {
            error = (
                <div className="fieldset-error">
                    {this.state.error}
                </div>
            );
        }

        return (
            <div className="social-connector-wrapper get-mastodon-handle">
                <div className="mastodon-form">
                    <form>
                        <fieldset>
                            <legend>Mastodon Handle<HelpButton which="mastodonHandle"/></legend>
                            {error}
                            <UncontrolledTextInput
                                className="text-input seventyfive"
                                placeholder="@username@server or https://server@username"
                                defaultValue=""
                                onChange={(e) => {
                                    if (e.target.value !== undefined) {
                                        this.setState({
                                            mastodonHandle: e.target.value
                                        });
                                    }
                                }}/>
                        </fieldset>
                    </form>
                </div>
                <div className="spread-buttons">
                    <button className="btn-primary reverse-fixed" onClick={this.closeAction}>
                        {"< go back"}
                    </button>
                    <button ref={this.buttonRef} className={connectClass} onClick={connectAction} data-direct={true}>
                        Connect
                    </button>
                </div>
            </div>
        );
    }
};

export default MastodonHandle;
